import { capitalize } from '@util';
import { CHANNELS } from '@consts';
import { getChannelName } from '@/utils/channelName';

export const refineAccountName = function (asset) {
    let { name, channelId, channel, architecture = {} } = asset;

    if (!name) {
        name = architecture?.name || getChannelName.call(this, channel, '-');
    }

    if (channel === CHANNELS.AMAZON) {
        const { name: amazonAdAccountName } = architecture;
        name = name || amazonAdAccountName || channelId || '-';
    } else if (channel === CHANNELS.NAVER_GFA) {
        name =
            asset.name ||
            asset.title ||
            getChannelName.call(this, 'naverGFA');
    } else if (channel === 'externalFiles') {
        name = `${capitalize(channel)} - ${channelId}`;
    }

    return name;
};
